















import Vue, { VueConstructor } from "vue";
import JoinScreen from "./JoinScreen";
export default JoinScreen;
